import createIcon from '../../createIcon';

/**
 * @component @name FilePresent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMkg2QzQuOSAyIDQgMi45IDQgNFYyMEM0IDIxLjEgNC45IDIyIDYgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjdMMTUgMlpNNiAyMFY0SDE0VjhIMThWMjBINlpNMTYgMTBWMTVDMTYgMTcuMjEgMTQuMjEgMTkgMTIgMTlDOS43OSAxOSA4IDE3LjIxIDggMTVWOC41QzggNy4wMyA5LjI2IDUuODYgMTAuNzYgNi4wMUMxMi4wNiA2LjE0IDEzIDcuMzMgMTMgOC42NFYxNUgxMVY4LjVDMTEgOC4yMiAxMC43OCA4IDEwLjUgOEMxMC4yMiA4IDEwIDguMjIgMTAgOC41VjE1QzEwIDE2LjEgMTAuOSAxNyAxMiAxN0MxMy4xIDE3IDE0IDE2LjEgMTQgMTVWMTBIMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FilePresent = createIcon('FilePresent', [
  [
    'path',
    {
      d: 'M15 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V7L15 2ZM6 20V4H14V8H18V20H6ZM16 10V15C16 17.21 14.21 19 12 19C9.79 19 8 17.21 8 15V8.5C8 7.03 9.26 5.86 10.76 6.01C12.06 6.14 13 7.33 13 8.64V15H11V8.5C11 8.22 10.78 8 10.5 8C10.22 8 10 8.22 10 8.5V15C10 16.1 10.9 17 12 17C13.1 17 14 16.1 14 15V10H16Z',
      key: 'y82hcc',
    },
  ],
]);

export default FilePresent;
